import { useActions } from 'shared/hooks';
import { postPaymentInfo } from 'store/payment/actions';
import { PaymentInfoFormData } from '../../../../api/payment/types';
import * as React from 'react';
import { redirectToUrl } from '../../survey/PaymentClaim/helpers';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../rootReducer';
import {
  selectPaymentRedirectTo,
  selectPaymentAlertLevel,
} from '../../../../store/payment/selectors';

export const usePaymentActions = () =>
  useActions({
    postPaymentInfo,
  });

export const usePaymentSelectors = () =>
  useSelector((state: RootState) => {
    return {
      redirect_to: selectPaymentRedirectTo(state),
      alert_level: selectPaymentAlertLevel(state),
    };
  });

export const useHandleSubmit = () => {
  const { postPaymentInfo: postAction } = usePaymentActions();
  return async (
    formData: PaymentInfoFormData,
    showError: React.Dispatch<React.SetStateAction<boolean>>,
  ) => {
    try {
      await postAction(formData);
    } catch (e) {
      showError(true);
    }
  };
};

export const useRedirectToUrl = (paymentPendingUrl: string) => {
  const { alert_level } = usePaymentSelectors();
  React.useEffect(() => {
    if (alert_level === 'success') {
      redirectToUrl(paymentPendingUrl);
    }
  }, [alert_level]);
};
